// @ts-nocheck
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-regular-svg-icons";
import { t } from "i18next";
import Button from "components/Button/Button";

export default function FormEndStep(props) {
	let form = props.object;

	function genPreviewText() {
		if (form.isDraft())
			return (
				<div>
					<div>{t("Forms.FORM_DRAFTED")}</div>
					<div><Button className="btn-primary" onClick={props.dispDrafts}>{t("Commons.SHOW_DRAFTS")}</Button></div>
				</div>
			);
		return (
			<div>
				{ t("Forms.FORM_SENDED") }
			</div>
		);
	}

	return (
		<div className="text-center inner-step-cont">
			{ genPreviewText() }
			<div style={{fontSize: "3.75em", color: "green"}}><FontAwesomeIcon icon={faCheckCircle}/></div>
		</div>
	);
}
